export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const USER_LOGOUT = 'USER_LOGOUT';
export const LOG_USER_IN = 'LOG_USER_IN';
export const API_CALL_FAILED = 'API_CALL_FAILED';
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_FORCE = 'LOGOUT_FORCE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const CHECK_AUTHENTICATED = 'CHECK_AUTHENTICATED';
export const CHECK_AUTHENTICATED_SUCCESS = 'CHECK_AUTHENTICATED_SUCCESS';
export const CHECK_AUTHENTICATED_FAILURE = 'CHECK_AUTHENTICATED_FAILURE';

export const FORGOT_PW = 'FORGOT_PW';
export const FORGOT_PW_SUCCESS = 'FORGOT_PW_SUCCESS';
export const FORGOT_PW_FAILURE = 'FORGOT_PW_FAILURE';

export const VERIFICATION_CODE_ENTERED = 'VERIFICATION_CODE_ENTERED';

export const NEW_PW_ENTERED = 'NEW_PW_ENTERED';
export const NEW_PW_ENTERED_SUCCESS = 'NEW_PW_ENTERED_SUCCESS';
export const NEW_PW_ENTERED_FAILURE = 'NEW_PW_ENTERED_FAILURE';

export const RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL';

export const RESEND_VERIFICATION_EMAIL_SUCCESS =
  'RESEND_VERIFICATION_EMAIL_SUCCESS';

export const RESEND_VERIFICATION_EMAIL_FAILURE =
  'RESEND_VERIFICATION_EMAIL_FAILURE';

export const LOGIN_CHANGE_SCREEN = 'LOGIN_CHANGE_SCREEN';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const SET_REGISTRATION_INFO = 'SET_REGISTRATION_INFO';
export const RESET_REGISTRATION_INFO = 'RESET_REGISTRATION_INFO';
export const SET_REGISTRATION_CURRENT_STEP = 'SET_REGISTRATION_CURRENT_STEP';

export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILURE = 'GET_USER_PROFILE_FAILURE';

export const GET_BUSINESS_ATTRIBUTES = 'GET_BUSINESS_ATTRIBUTES';

export const GET_BUSINESS_ATTRIBUTES_SUCCESS =
  'GET_BUSINESS_ATTRIBUTES_SUCCESS';

export const GET_BUSINESS_ATTRIBUTES_FAILURE =
  'GET_BUSINESS_ATTRIBUTES_FAILURE';

export const SET_USER_PROFILE_CUSTOM_ATTRIBUTE =
  'SET_USER_PROFILE_CUSTOM_ATTRIBUTE';

// this action type is used when 'Update Details' button is clicked
export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
export const EDIT_USER_PROFILE_CANCELLED = 'EDIT_USER_PROFILE_CANCELLED';

// this action type is used when the 'update details form' is actually submitted
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';

export const UPDATE_BUSINESS_ATTRIBUTES = 'UPDATE_BUSINESS_ATTRIBUTES';
export const UPDATE_BUSINESS_ATTRIBUTES_SUCCESS =
  'UPDATE_BUSINESS_ATTRIBUTES_SUCCESS';
export const UPDATE_BUSINESS_ATTRIBUTES_FAILURE =
  'UPDATE_BUSINESS_ATTRIBUTES_FAILURE';

export const GET_SKILLSET_OPTIONS_OF_TYPE = 'GET_SKILLSET_OPTIONS_OF_TYPE';

export const GET_SKILLSET_OPTIONS_OF_TYPE_SUCCESS =
  'GET_SKILLSET_OPTIONS_OF_TYPE_SUCCESS';

export const GET_JOBS = 'GET_JOBS';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';
export const GET_JOBS_FAILURE = 'GET_JOBS_FAILURE';

export const CREATE_JOB = 'CREATE_JOB';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_FAILURE = 'CREATE_JOB_FAILURE';

export const UPDATE_JOB = 'UPDATE_JOB';
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS';
export const UPDATE_JOB_FAILURE = 'UPDATE_JOB_FAILURE';

export const BUILD_TOOLS = 'BUILD_TOOLS';
export const BUILD_TOOLS_SUCCESS = 'BUILD_TOOLS_SUCCESS';
export const BUILD_TOOLS_FAILURE = 'BUILD_TOOLS_FAILURE';

export const RESET_JOBS_STATE = 'RESET_JOBS_STATE';
export const RESET_MODAL_STATE = 'RESET_MODAL_STATE';
export const RESET_NAVIGATION_STATE = 'RESET_NAVIGATION_STATE';
export const RESET_REGISTRATION_STATE = 'RESET_REGISTRATION_STATE';
export const RESET_SKILLSET_STATE = 'RESET_SKILLSET_STATE';
export const RESET_USER_PROFILE_STATE = 'RESET_USER_PROFILE_STATE';

export const UPDATE_NOTIFICATION_SETTINGS = 'UPDATE_NOTIFICATION_SETTINGS';

export const UPDATE_NOTIFICATION_SETTINGS_SUCCESS =
  'UPDATE_NOTIFICATION_SETTINGS_SUCCESS';

export const UPDATE_NOTIFICATION_SETTINGS_FAILURE =
  'UPDATE_NOTIFICATION_SETTINGS_FAILURE';

export const CONFIRM_APPROVE_BUILDER = 'CONFIRM_APPROVE_BUILDER';
export const DEACTIVATE_BUILDER = 'DEACTIVATE_BUILDER';
export const CONFIRM_APPROVE_BUILDER_SUCCESS =
  'CONFIRM_APPROVE_BUILDER_SUCCESS';
export const CONFIRM_APPROVE_BUILDER_FAILURE =
  'CONFIRM_APPROVE_BUILDER_FAILURE';

export const GET_BUILDER_LOGO = 'GET_BUILDER_LOGO';
export const GET_BUILDER_BANNER = 'GET_BUILDER_BANNER';
export const GET_BUILDER_PROJECT_GALLERY = 'GET_BUILDER_PROJECT_GALLERY';
export const REMOVE_IMAGE_FROM_BUILDER_PROJECT_GALLERY =
  'REMOVE_IMAGE_FROM_BUILDER_PROJECT_GALLERY';
export const RESET_BUILDER_PROJECT_GALLERY = 'RESET_BUILDER_PROJECT_GALLERY';
